// extracted by mini-css-extract-plugin
module.exports = {"root":"price-discount-strike_root__w5lQh"};